export default __webpack_public_path__ + "static/media/Meaningful.fe1915e1.svg";